import React from "react";
import { withRouter } from "react-router-dom";

import { PendingComponent, Backbutton } from "../components/_common";
import { Layout } from "../components/_layout";

const CampaignsByInterest = ({ match }) => {
  return (
    <Layout leftContainerChildren={<Backbutton />}>
      <PendingComponent message="Este componente está en desarrollo." />
    </Layout>
  );
};

export default withRouter(CampaignsByInterest);
